import WebApiService from './WebApiService';

export default class ExportService extends WebApiService {

	constructor() {
		super();

		this.post = super.post.bind(this);
		this.get = super.get.bind(this);

		this.excel = this.excel.bind(this);
		this.csv = this.csv.bind(this);
		this.pdf = this.pdf.bind(this);
	}

	excel(excelExportModel, successCallback, errorCallback) {
		this.post('/api/export/excel',excelExportModel, successCallback, errorCallback);
	}

	csv(csvExportModel, successCallback, errorCallback) {
		this.post('/api/export/csv',csvExportModel, successCallback, errorCallback);
	}

	pdf(pdfExportModel, successCallback, errorCallback) {
		this.post('/api/export/pdf',pdfExportModel, successCallback, errorCallback);
	}
}